import * as ReactDOM from "react-dom/client";

const browserHydrateFunction = () => {
  return (element: React.ReactNode, container: ReactDOM.Container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export default browserHydrateFunction;
